import { useTranslation } from "react-i18next";
import { ChangeEvent, useCallback, useState, useEffect } from "react";
import Dialog from "components/common/Dialog/Dialog";
import Button from "components/common/Button/Button";
import {
  ContainerButtonStyle,
  DeleteButtonsStyle,
  InputStyle,
} from "./EditTax.style";
import { useSnackBar } from "hooks/useSnackBar";
import TextInput from "components/common/TextInput/TextInput";
import {
  ITaxEditingData,
  ITaxEditingDataError,
  IEditingDialog,
  ICountry,
} from "./EditTax.types";
import { useUpdateTaxMutation } from "redux/api/tax/taxes";
import {
  Select,
  SelectChangeEvent,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Autocomplete,
  TextField,
} from "@mui/material";
import countries from "../TaxAdd/countries.json";

function EditTax({
  iniData,
  openEditingDialog,
  setOpenEditingDialog,
}: IEditingDialog) {

  const { t } = useTranslation();
  console.log('zeze', iniData)
  const { displaySuccessSnackBar, displayErrorApiSnackBar } = useSnackBar();

  const [editingTax, { data, error, isLoading, reset }] =
    useUpdateTaxMutation();

  if (error) {
    displayErrorApiSnackBar(error);
    reset();
  }
  if (data) {
    displaySuccessSnackBar(t("tax.successfully_editing"));
    reset();
  }
  const closeEditingDialog = useCallback(() => {
    setOpenEditingDialog(false);
    setEditingData({ name: "", percentage: "", country: null });
    setEditingError({ name: "", percentage: "", country: "" });
  }, [setOpenEditingDialog]);

  const onSuccessEditingDialog = async (event: React.FormEvent) => {
    event.preventDefault();
    if (areAllValuesEmpty(editingError)) {
      editingTax({
        id: editingData.id,
        name: editingData.name,
        percentage: editingData.percentage,
        country: editingData.country,
      });
      closeEditingDialog();
    }
  };
  function areAllValuesEmpty(obj: Object) {
    return Object.values(obj).every((value) => {
      if (typeof value === "object" && !Array.isArray(value)) {
        return Object.values(value).every((innerValue) => {
          return innerValue === null || innerValue === "";
        });
      } else {
        return value === null || value === "";
      }
    });
  }

  const [editingData, setEditingData] = useState<ITaxEditingData>({
    id: iniData.id,
    name: iniData.name,
    percentage: iniData.percentage,
    country: iniData.country,
  });
  console.log(editingData, 'eeeeee')
  const [editingError, setEditingError] = useState<ITaxEditingDataError>({
    name: "",
    percentage: "",
    country: "",
  });
  console.log(editingData)
  const onChange = useCallback(
    (field: string) => (value: any) => {
      if (field === "country" && value && typeof value === "object") {
        value = value.name_fr;
      }

      setEditingData((prevData) => {
        const newData = {
          ...prevData,
          [field]: value,
        };

        // Handle validations
        if (newData.name === "") {
          setEditingError((prevError) => ({
            ...prevError,
            name: "Nom obligatoire",
          }));
        } else {
          setEditingError((prevError) => ({ ...prevError, name: "" }));
        }

        if (newData.country === null) {
          setEditingError((prevError) => ({
            ...prevError,
            country: "Pays obligatoire",
          }));
        } else {
          setEditingError((prevError) => ({ ...prevError, country: "" }));
        }

        if (newData.percentage === "") {
          setEditingError((prevError) => ({
            ...prevError,
            percentage: "Pourcentage obligatoire",
          }));
        } else if (
          parseFloat(newData.percentage) < 0.0 ||
          parseFloat(newData.percentage) > 100.0
        ) {
          setEditingError((prevError) => ({
            ...prevError,
            percentage: "Pourcentage entre 0 et 100",
          }));
        } else {
          setEditingError((prevError) => ({ ...prevError, percentage: "" }));
        }

        return newData;
      });
    },
    []
  );
  const selectedCountry = countries.find(
    (country) => country.name_fr === editingData.country
  );
  console.log(selectedCountry)
  console.log(editingData)
  useEffect(() => {
    if (openEditingDialog) {
      const selectedCountry = countries.find(
        (country) => country.name_fr === (typeof iniData.country === 'string' ? iniData.country : '')
      ) || null;
      setEditingData({
        id: iniData.id,
        name: iniData.name,
        percentage: iniData.percentage,
        country: selectedCountry ? selectedCountry.name_fr : null,
      });
    }
  }, [
    openEditingDialog,
    iniData.id,
    iniData.name,
    iniData.percentage,
    iniData.country,
  ]);
  function convertUnicodeToEmoji(unicode: string) {
    return unicode
      .split(' ')
      .map(u => String.fromCodePoint(parseInt(u.replace('U+', ''), 16)))
      .join('');
  }
  return (
    <Dialog
      open={openEditingDialog}
      handleClose={closeEditingDialog}
      title={t("tax.edit")}
    >
      <form onSubmit={onSuccessEditingDialog}>
        <InputStyle>
          <TextInput
            value={editingData.name}
            label={t("tax.name")}
            onChange={(e) => onChange("name")(e.target.value)}
            error={t(editingError.name)}
          />
        </InputStyle>
        <InputStyle>
          <TextInput
            value={parseFloat(editingData.percentage).toString()}
            label={t("tax.percentage")}
            type="number"
            onChange={(e) => onChange("percentage")(e.target.value)}
            error={t(editingError.percentage)}
          />
        </InputStyle>
        <FormControl fullWidth>
          <Autocomplete
            options={countries}
            value={
              countries.find(
                (country) => country.name_fr === iniData.country
              )
            }
            onChange={(event, newValue) => onChange("country")(newValue)}
            getOptionLabel={(option) => (option ? option.name_fr : "")}
            isOptionEqualToValue={(option, value) => option.id === value?.id}
            renderOption={(props, option) => (
              <li {...props} key={option.id}>
                {convertUnicodeToEmoji(option.emojiU)} {option.name_fr}
              </li>
            )}
            renderInput={(params) => (
              <TextField
                label={t("tax.country")}
                {...params}
                variant="outlined"
              />
            )}
          />
        </FormControl>
        <DeleteButtonsStyle>
          <ContainerButtonStyle>
            <Button
              disabled={isLoading}
              title={t("common.cancel_button")}
              onClick={closeEditingDialog}
            />
          </ContainerButtonStyle>
          <ContainerButtonStyle>
            <Button
              disabled={isLoading}
              type="submit"
              loader={isLoading}
              title={t("common.confirm_button")}
            />
          </ContainerButtonStyle>
        </DeleteButtonsStyle>
      </form>
    </Dialog>
  );
}
export default EditTax;
